<app-iota-modal [title]="service.typeConfig()?.dialogTitle" [modalOptions]="modalOptions" (close$)="closeDialog()">
    <div modal-body>
        <div class="flex flex-col gap-3" *ngIf="service.isInFirstStep()">
            <span class="font-bold text-xl">{{ service.typeConfig()?.firstStepTitle }}</span>
            <span>{{ service.typeConfig()?.firstStepDescription }}</span>
        </div>
        <app-smart-dialog-steps [stepLabels]="service.stepLabels()" [currentStep]="service.currentStepIndex()"></app-smart-dialog-steps>

        <div *ngIf="service.isInProductStep()" class="mt-5">
            <app-smart-assistant-product-step></app-smart-assistant-product-step>
        </div>

        <div *ngIf="service.isInUrbanSportsClubDateStep()" class="mt-5">
            <app-smart-assistant-urban-sports-club-date-step></app-smart-assistant-urban-sports-club-date-step>
        </div>

        <div *ngIf="service.isInUploadStep()" class="mt-5">
            <app-smart-assistant-upload-step (fileSelected)="onFileSelected($event)"></app-smart-assistant-upload-step>
        </div>

        <div *ngIf="service.isInAssignColumnsStep()" class="mt-5">
            <app-smart-assistant-column-mapping-step></app-smart-assistant-column-mapping-step>
        </div>

        <div *ngIf="service.isInValidateDataStep()" class="mt-5">
            <app-smart-assistant-validation-step></app-smart-assistant-validation-step>
        </div>

        <div *ngIf="service.isInCompletionStep()" class="mt-5">
            <app-smart-assistant-completion-step></app-smart-assistant-completion-step>
        </div>
    </div>

    <div modal-footer class="grid grow grid-cols-3 items-center">
        <div class="justify-self-start">
            <button class="btn btn-sm btn-ghost rounded-full" *ngIf="service.isInFirstStep()" (click)="closeDialog()" i18n>Cancel</button>
            <button
                class="btn btn-sm btn-ghost rounded-full"
                *ngIf="!service.isInFirstStep() && !service.isInCompletionStep()"
                data-testid="smartAssistantBackBtn"
                (click)="previousStep()"
            >
                <span i18n>Back</span>
            </button>
        </div>

        <div class="justify-self-center">
            <button
                *ngIf="(service.isInValidateDataStep() && service.hasErrors()) || service.isInCompletionStep()"
                class="btn btn-sm btn-outline rounded-full"
                (click)="downloadReport()"
            >
                <span *ngIf="!service.isInCompletionStep()" i18n>Download validation list</span>
                <span *ngIf="service.isInCompletionStep()" i18n>Download processing report</span>
            </button>
        </div>

        <div class="justify-self-end flex items-center gap-2">
            <button
                *ngIf="!service.isInCompletionStep()"
                class="btn btn-sm btn-primary rounded-full flex flex-row items-center gap-2"
                [ngClass]="{ loading: service.isBusy() }"
                [disabled]="service.nextButtonDisabled()"
                [attr.data-testid]="service.isInValidateDataStep() ? 'smartAssistantSubmitBtn' : 'smartAssistantContinueBtn'"
                (click)="nextStep()"
            >
                <span *ngIf="!service.isInValidateDataStep()" i18n>Continue</span>
                <span *ngIf="service.isInValidateDataStep()" i18n>Submit</span>
                <div><iota-icon icon="arrow-long-right"></iota-icon></div>
            </button>
            <ng-container *ngIf="service.isInCompletionStep()">
                <button
                    *ngIf="service.resultPage() as resultPage"
                    class="btn btn-sm btn-outline rounded-full"
                    data-testid="smartAssistantShowResultsBtn"
                    (click)="showResults(resultPage.route)"
                >
                    {{ resultPage.label }}
                </button>
                <button class="btn btn-sm btn-primary rounded-full" data-testid="smartAssistantCloseBtn" (click)="closeDialog()" i18n>
                    Close
                </button>
            </ng-container>
        </div>
    </div>
</app-iota-modal>
